import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setOverrideJustification')(function setOverrideJustification(
    viewState: PolicyTipsViewState,
    justification: string
) {
    viewState.isOverridden = justification != null ? true : false;
    viewState.overrideJustification = justification;
});
